import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import templateServices from './templateServices';
import { CommonUtilities } from 'commonUtils';

export default function TemplateDrawer(param: any) {


    console.log(param)


    let [tableColumn, setTableColumn] = useState<any>([]);
    useEffect(() => {


        let [schema, table] = param.EditTemplate.viewName.replace(/\[|\]/g, '').split('.');


        if (!table) {
            table = schema;
            schema = 'dbo'
        }

        var payload = {
            templateName: table,
            templateSchema: schema,
            type: "templateHeader"
        }


        console.log(payload)
        console.log(schema)
        console.log(table)
        templateServices.genericAPIListing(payload).then((value: any) => {
            var obj = (CommonUtilities.relativeDataRemapping(value.data, value.headers.original));
            tableColumn = obj
            setTableColumn(tableColumn)
            console.log(tableColumn)
        })
    }, [param]);

    const close = () => {
        param.closeTemplateDrawer();
    }


    return (

        <div>
            <Drawer open={param.openDrawer} onClose={() => { close(); }} size={300} direction='left'
                className='react-drawer-left full-height-vh allowHscroll allowVscroll' >

                <div className="box noBorderRadius noBorder ws-5 full-height-vh">
                    <div className="box-header  noBorderRadius bg-blue pm">
                        Edit Template
                    </div>

                    <div className='ws-12 pLarge allowHscroll allowVscroll full-height-vhmM'>

                        <div className='ws-6 pull-left pm'>
                            <h2>Currect Template Mapping</h2>
                            {
                                param.EditTemplate.templateHeader?.split(",")?.map((values: any) => {
                                    return (<input className="ws-12 pm ws-12  mt" value={values} readOnly />)
                                })
                            }
                        </div>

                        <div className='ws-6 pull-right pm'>
                            <h2>Korrect Table Header</h2>
                            {
                                tableColumn?.map((values: any) => {
                                    return (
                                        <div>

                                            <div className="ps ws-5 pl">
                                                <input className="ws-12" value={values.cOLUMN_NAME} readOnly />
                                            </div>

                                            <div className="ps ws-5 pl">
                                                <input className="ws-12" value={values.dATA_TYPE} readOnly />
                                            </div>

                                        </div>)
                                })
                            }
                        </div>
                    </div>

                    <div className="box-footer">
                        <button className="icon-btn delete pull-right" onClick={() => close()}> Close </button>

                    </div>
                </div>


            </Drawer>

        </div>
    )
}